import { Role } from "@enums";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface Auth0State {
  isAuthenticated: boolean;
  user: string;
  token: string;
  idToken: string;
  roles: Role[];
  tenants: string[];
  preferredRole?: Role | undefined;
}

const initialState: Auth0State = {
  isAuthenticated: false,
  user: "",
  token: "",
  idToken: "",
  roles: [],
  tenants: [],
  preferredRole: undefined,
};

export const auth0Slice = createSlice({
  name: "auth0",
  initialState,
  reducers: {
    setCredentials(
      state,
      action: PayloadAction<{
        user: string;
        token: string;
        idToken: string;
        roles: Role[];
        tenants: string[];
        preferredRole?: Role | undefined;
      }>,
    ) {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.idToken = action.payload.idToken;
      state.roles = action.payload.roles;
      state.tenants = action.payload.tenants;
      state.preferredRole =
        action.payload.preferredRole ||
        (action.payload.roles.includes(Role.RO)
          ? Role.RO
          : action.payload.roles.includes(Role.DOSIMETRIST)
            ? Role.DOSIMETRIST
            : undefined);
    },
    logOut(state) {
      state.isAuthenticated = false;
      state.user = "";
      state.token = "";
      state.idToken = "";
      state.roles = [];
      state.tenants = [];
      state.preferredRole = undefined;
    },
    setPreferredRole(state, action: PayloadAction<Role>) {
      state.preferredRole = action.payload;
    },
  },
});

export const { setCredentials, logOut, setPreferredRole } = auth0Slice.actions;
export default auth0Slice.reducer;
